/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodeCompat } from '../../../../compat/NodeCompat';
import { Constants } from '../../../Constants';
import { Node } from '../../../models/Node';
import { IDefinition } from '../../../models/common/IDefinition';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasMissingResponseDefinitionDescriptionRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        if(this.hasValue(NodeCompat.getProperty(node, Constants.PROP_$REF))) {
            return;
        }
        this.requireProperty(<Node><any>node, Constants.PROP_DESCRIPTION, this.map("name", node.getName()));
    }
}
OasMissingResponseDefinitionDescriptionRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.OasMissingResponseDefinitionDescriptionRule";
OasMissingResponseDefinitionDescriptionRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




